var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "f9aa066977acae3eb45e02b4079afe64d49bd4f0"
};